import classNames from "classnames";
import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";
import styles from "./css/IconButton.module.css";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  // 아이콘만 있는 버튼은 스크린리더용 이름이 반드시 필요하다.
  "aria-label": string;
  icon: ReactNode;
  variant?: "ghost" | "filled" | "primary";
  size?: "sm" | "md" | "lg";
  active?: boolean;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(
    {
      icon,
      variant = "ghost",
      size = "md",
      active = false,
      className,
      type = "button",
      ...rest
    },
    ref
  ) {
    return (
      <button
        ref={ref}
        type={type}
        aria-pressed={active || undefined}
        className={classNames(
          styles.iconButton,
          styles[variant],
          styles[size],
          { [styles.active]: active },
          className
        )}
        {...rest}
      >
        {icon}
      </button>
    );
  }
);

export default IconButton;
